var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#596269",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4H13V6H10V15H17V10H19V15C19 16.1 18.1 17 17 17H16V18C16 19.1046 15.1046 20 14 20H7C5.89543 20 5 19.1046 5 18V9C5 7.89543 5.89543 7 7 7H8V6C8 4.9 8.9 4 10 4ZM8 9H7V18H14V17H10C8.9 17 8 16.1 8 15V9Z",
    fill: "#596269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H14.4L19 8.6V9H14V4Z",
    fill: "#596269"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copyIcon.69988acd89af15b1619cb4bf2a7d260d.svg";